<template>
  <div class="manner_box">
    <h3 class="activeR">我的态度</h3>
    <el-tabs v-model="is_win" @tab-click="handleClick">
      <el-tab-pane label="全部" :name="'2'"></el-tab-pane>
      <el-tab-pane label="中奖" :name="'1'"></el-tab-pane>
      <el-tab-pane label="未中奖" :name="'0'"></el-tab-pane>
    </el-tabs>
    <div style="overflow-y: hidden">
      <div
        class="information_box"
        v-infinite-scroll="load"
        style="overflow: auto"
      >
        <el-card
          v-for="(item, index) in release_notes_l"
          :key="index"
          class="cuP"
          @click="fnRead(item.note_id)"
        >
          <span
            class="icon_mm"
            v-if="item.first_choice >= 0 && 'first_choice' in item"
          >
            <svg
              v-if="
                item.match_state == -1 &&
                (item.first_result == 1 || item.two_result == 1)
              "
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-hit"></use>
            </svg>
            <svg
              v-else-if="
                item.match_state !== -1 &&
                !item.first_result &&
                !item.two_result
              "
              class="icon"
              aria-hidden="true"
            >
              <use
                xlink:href="#icon-weikaishi2
"
              ></use>
            </svg>
            <svg
              v-else-if="item.match_state == -1"
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-weimingzhong"></use>
            </svg>
          </span>
          <h6>
            <span
              >[{{ item.sclass_name }}] {{ item.home_team_name }}
              <b>{{
                item.match_state === -1
                  ? item.home_score + '-' + item.guest_score
                  : $filters.match_state(item.match_state)
              }}</b>
              {{ item.guest_team_name }}</span
            >
          </h6>
          <b
            class="activeR"
            v-if="item.first_choice >= 0 && 'first_choice' in item"
            >{{
              item.two_choice == null
                ? item.note_type == 1
                  ? `单选:${choice_type[item.first_choice]}`
                  : item.note_type == 2
                  ? `单选:(${item.goal > 0 ? `+${item.goal}` : item.goal})主${
                      choice_type[item.first_choice]
                    }`
                  : item.note_type == 3
                  ? `单选:(${item.goal})${
                      item.first_choice == 3 ? '大球' : '小球'
                    }`
                  : ''
                : `首选:${choice_type[item.first_choice]}&nbsp;&nbsp;&nbsp;`
            }}{{
              item.two_choice != null
                ? `次选:${choice_type[item.two_choice]}`
                : ''
            }}</b
          >
          <div class="content">{{ item.content }}</div>
          <p class="pp">
            <span>{{ item.public_time }}</span>
            <span class="pp_span">
              <span><i class="el-icon-s-promotion"></i>转发</span>
              <span><i class="el-icon-chat-dot-square"></i>评论</span>
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      >({{
                        item.is_open ? '公开' : '不公开'
                      }})</el-dropdown-item
                    >
                    <el-dropdown-item>关闭评论</el-dropdown-item>
                    <el-dropdown-item>投诉</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </span>
          </p>
        </el-card>
        <p v-if="loading" class="loading">加载中...</p>
        <p v-if="noMore" class="loading">没有更多了</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, ref, reactive } from 'vue'
import '../../../assets/font/iconfont'
import { useRouter } from 'vue-router'
export default {
  props: ['AUTH_OBJ', 'token'],
  setup() {
    let router = useRouter()
    let { proxy: _this } = getCurrentInstance()
    // 是否中奖
    let is_win = ref('2')
    let is_wins = ''
    let handleClick = (v) => {
      console.log(v.props.name)
      is_wins = v.props.name
      pages.value = 1
      release_notes_l.value = []
      load()
    }
    // 笔记列表
    let loading = ref(true)
    let noMore = ref(false)
    let release_notes_l = ref([])
    let pages = ref(1)
    let release_notes_list = async () => {
      if (is_win.value == 2) is_wins = ''
      let formData = reactive({
        page: pages.value,
        is_win: is_wins
      })
      let { data: res } = await _this.$http.get(
        `/auth/user/release_notes_list`,
        {
          params: formData
        }
        // ${props.AUTH_OBJ.user_id}
      )
      console.log(res.data)
      if (res.data.length === 0) {
        loading.value = false
        noMore.value = true
        _this.$notify({
          title: '提示',
          message: '已加载全部内容',
          type: 'error'
        })
      }
      release_notes_l.value = release_notes_l.value.concat(
        ...JSON.parse(JSON.stringify(res.data))
      )
    }
    // 无限滚动
    const load = () => {
      release_notes_list()
      pages.value++
    }
    // 跳转
    let fnRead = (note_ids) => {
      // 直接阅读
      let routeUrl = router.resolve({
        path: `/note_details/${note_ids}`
      })
      window.open(routeUrl.href, '_blank')
    }
    // watch(
    //   () => props.AUTH_OBJ,
    //   (n) => {
    //     if (n) {
    //       load()
    //     }
    //   }
    // )
    // load()
    return {
      is_win,
      handleClick,
      release_notes_l,
      load,
      loading,
      noMore,
      choice_type: {
        3: '胜',
        1: '平',
        0: '负'
      },
      fnRead
    }
  }
}
</script>
<style scoped lang="less">
.manner_box {
  h3 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  b {
    color: #000;
    font-size: 14px !important;
  }
  .el-card {
    position: relative;
    .icon_mm {
      position: absolute;
      right: 10px;
      top: -30px;
      .icon {
        width: 80px;
      }
    }
    h6 {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 10px 0;
      .xz {
        font-size: 14px;
        padding: 2px 6px;
        background: red;
        border-radius: 4px;
        color: #fff;
      }
      .activeH5 {
        background: #606266;
      }
    }
    .activeH {
      // margin: 10px;
    }
    .content {
      background: #eee;
      padding: 10px;
      font-size: 14px;
      border-radius: 10px;
      margin: 10px 0;
    }
    .pp {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #8c8c8c;
      font-weight: 600;
      .pp_span {
        span {
          margin: 0 10px;
        }
      }
    }
  }
}
.information_box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
.information_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.information_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.information_box {
  height: 600px;
}
.loading {
  color: #8c8c8c;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
